import { gql } from '../../__generated__';
import { UserItem } from '../../interfaces.graphql';

const LicenseItemComposite = gql(`
  fragment LicenseContactItem on LicenseContactModel {
    license {
      id
      pendingContact
    }
    bksLicense {
      id
      contact {
        ...UserItem
      }
    }
  }
`);

export const GET_CONTACT = gql(`
  query GetContact($id: Int!) {
    licenseContact: licenseContact(licenseId: $id) {
      ...LicenseContactItem
    }
  }
`);

export const UPDATE_CONTACT = gql(`
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      ...LicenseContactItem
    }
  }
`);

export const CANCEL_UPDATE_CONTACT = gql(`
  mutation CancelUpdateContact($input: CancelUpdateContactInput!) {
    cancelUpdateContact(input: $input) {
      ...LicenseContactItem
    }
  }
`);
